module.exports = __webpack_public_path__ + "static/media/arrow_downward_on.91a7fa32.svg";